import NavbarV2 from '../../components/navbarV2/NavbarV2';
import './AccountV2.css';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const AccountV2 = () => {
    const [account, setAccount] = useState({});

    const navigate = useNavigate();

    useEffect(() => {
        getAccount();
    }, []);


    const getAccount = () => {
        if (localStorage.getItem('account') == null) navigate('/login')
        fetch(`${process.env.REACT_APP_API}/api/getAccount/${localStorage.getItem('account')}`, {})
        .then(response => {
            if (response.status === 200) {
                response.json().then(data => {
                    setAccount(data);
                });
            }
        })
    }

    const updateAccount = (e) => {
        e.preventDefault();
        const name = document.getElementById("name").value;
        const campanyName = document.getElementById("campanyName").value;
        const VAT = document.getElementById("VAT").value;
        const street = document.getElementById("street").value;
        const city = document.getElementById("city").value;
        const postCode = document.getElementById("postCode").value;
        const phone = document.getElementById("phone").value;
        const email = document.getElementById("email").value;

        if (name === "") {
            toast.error('Name is required.');
            return;
        }
        if (street === "") {
            toast.error('Street is required.');
            return;
        }
        if (city === "") {
            toast.error('City is required.');
            return;
        }
        if (postCode === "") {
            toast.error('Post Code is required.');
            return;
        }
        if (phone === "") {
            toast.error('Phone is required.');
            return;
        }
        if (email === "") {
            toast.error('Email is required.');
            return;
        }

        fetch(`${process.env.REACT_APP_API}/api/updateAccount/${account._id}`, {
            method: 'POST',
            
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json'
            },
            redirect: 'follow',
            referrerPolicy: 'no-referrer',
            body: JSON.stringify({
                name: name,
                campanyName: campanyName,
                VAT: VAT,
                street: street,
                city: city,
                postCode: postCode,
                phone: phone,
                email: email
            })
        })
        .then(response => {
            if (response.status === 200) {
                toast.success('Updated account!')
            } else if (response.status === 500) {
                response.json().then(data => {
                    toast.error(data)
                })
            }
        });
    }

    const updatePassword = (e) => {
        e.preventDefault();
        const password = document.getElementById("password").value;
        const confirmpassword = document.getElementById("confirmpassword").value;

        if (password === "") {
            toast.error('Password is required.');
            return;
        }
        if (confirmpassword !== password) {
            toast.error('Passwords do not match.');
            return;
        }

        fetch(`${process.env.REACT_APP_API}/api/updatePassword/${account._id}`, {
            method: 'POST',
            
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json'
            },
            redirect: 'follow',
            referrerPolicy: 'no-referrer',
            body: JSON.stringify({
                password: password,
            })
        })
        .then(response => {
            if (response.status === 200) {
                toast.success('Changed password!')
            } else if (response.status === 500) {
                toast.error('Server error.')
            }
        });
    }

    return (
        <div className="v2-page accountv2">
            <NavbarV2 />

            <div className="v2-container">
                <h1 className="v2-h1">Account</h1>
                <p className="v2-muted accountv2-lead">Update billing details, change your password, or sign out.</p>

                <div className="accountv2-grid">
                    <div className="v2-card">
                        {account && (
                            <form
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    updateAccount(e);
                                }}
                            >
                                <h2 className="v2-card-title">Billing details</h2>

                                <div className="v2-field">
                                    <label htmlFor="name">Full name</label>
                                    <input type="text" name="name" defaultValue={account.name} id="name" />
                                </div>

                                <div className="v2-field">
                                    <label htmlFor="campanyName">Company name</label>
                                    <input type="text" name="campanyName" defaultValue={account.campany} id="campanyName" />
                                </div>

                                <div className="v2-field">
                                    <label htmlFor="VAT">VAT no.</label>
                                    <input type="text" name="VAT" defaultValue={account.VAT} id="VAT" />
                                </div>

                                <div className="v2-field">
                                    <label htmlFor="street">Street address</label>
                                    <input type="text" name="street" defaultValue={account.street} id="street" />
                                </div>

                                <div className="v2-field">
                                    <label htmlFor="city">Town / city</label>
                                    <input type="text" name="city" defaultValue={account.city} id="city" />
                                </div>

                                <div className="v2-field">
                                    <label htmlFor="postCode">Post code</label>
                                    <input type="text" name="postCode" defaultValue={account.postCode} id="postCode" />
                                </div>

                                <div className="v2-field">
                                    <label htmlFor="phone">Phone</label>
                                    <input type="tel" name="phone" defaultValue={account.phone} id="phone" />
                                </div>

                                <div className="v2-field">
                                    <label htmlFor="email">Email</label>
                                    <input type="email" name="email" defaultValue={account.email} id="email" />
                                </div>

                                <div className="v2-actions">
                                    <button type="submit" className="v2-btn v2-btn--primary">
                                        Save profile
                                    </button>
                                </div>
                            </form>
                        )}
                    </div>

                    <aside className="v2-card accountv2-sidebar">
                        <form
                            onSubmit={(e) => {
                                e.preventDefault();
                                updatePassword(e);
                            }}
                        >
                            <h2 className="v2-card-title">Security</h2>

                            <div className="v2-field">
                                <label htmlFor="password">New password</label>
                                <input type="password" name="password" id="password" autoComplete="new-password" />
                            </div>

                            <div className="v2-field">
                                <label htmlFor="confirmpassword">Confirm password</label>
                                <input type="password" name="confirmpassword" id="confirmpassword" autoComplete="new-password" />
                            </div>

                            <div className="v2-actions">
                                <button type="submit" className="v2-btn v2-btn--outline">
                                    Update password
                                </button>
                            </div>
                        </form>

                        <div className="accountv2-logout-block">
                            <p className="v2-muted">Finished shopping on this device?</p>
                            <button
                                type="button"
                                className="v2-btn v2-btn--danger"
                                onClick={() => {
                                    localStorage.removeItem('account');
                                    localStorage.removeItem('admin');
                                    location.reload();
                                }}
                            >
                                Log out
                            </button>
                        </div>
                    </aside>
                </div>
            </div>
        </div>
    );
}

export default AccountV2;